module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:svg": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    staticClass: "scale"
  }, [_c('path', {
    attrs: {
      "id": "svg_1",
      "d": "m7.9131,2l0,-1.548l-2.586,2.155l0,-2.171l-2.582,2.208l2.582,2.175l0,-2.139l2.586,2.155l0,-1.276c3.138,0.129 5.491,2.681 5.543,5.838l-1.031,0l0.016,0.215l1.015,0c-0.06,3.19 -2.629,5.765 -5.819,5.833l0,-1.018l-0.214,0l0,1.021c-3.21,-0.047 -5.801,-2.631 -5.862,-5.836l1.045,0l-0.016,-0.215l-1.045,0c-0.052,-0.288 -0.318,-0.654 -0.766,-0.654c-0.538,0 -0.755,0.484 -0.755,0.75c0,4.146 3.331,7.506 7.476,7.506c4.146,0 7.506,-3.36 7.506,-7.506c0,-4.059 -3.066,-7.357 -7.093,-7.493"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(0.3479215204715729,0,0,0.3479215204715729,-1.6505736513063312,9.74042228795588) ",
      "xml:space": "preserve",
      "text-anchor": "middle",
      "font-family": "Helvetica",
      "font-size": "24",
      "id": "svg_3",
      "y": "6.666065",
      "x": "24.443859",
      "stroke-width": "0"
    }
  }, [_vm._v("10")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-6307ac90"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JumpBackIcon.vue
// module id = 1048
// module chunks = 0